import { forecastChartConfig } from '../../../features/ForecastCharts/config/forecastCharts.config';

export const route = 'combinedCharts';

export const getCombinedChartDefinition = (selectedIndex) =>
  forecastChartConfig[selectedIndex] ?? forecastChartConfig[0];
